<template>
  <div class="d-flex align-center" @click="navigateTo('/')" style="cursor: pointer;">
    <v-img
      :src="items?.logo"
      width="65"
      height="65"
      class="flex-0-0"
    ></v-img>
    <p class="px-2 header">{{ $t("Brand") }}</p>
  </div>
</template>
<script>
  import crudDataService from "@/Services/crudDataService";

export default {
  data() {
    return {
      items: {},
    };
  },
  components: {},
  methods: {
    navigateTo(route) {
      this.$router.push(route)
    },
     async getcontact() {
        let response = await crudDataService.getAll("application-data");
        this.items = response.data.data;
      },
  },
  mounted() {
      this.getcontact();
    },
};
</script>
<style lang="scss" scoped></style>
